module.exports = __webpack_public_path__ + "static/media/honey-cornflakes.c66b21e6.png";